/** One spacing system for the auth (login / sign-up) pages.
 *  Breakpoints map to mobile (xs) / tablet (sm) / desktop (md+). */
export const PAGE_MAX_WIDTH = "1440px";

export const PAGE_GUTTER = { xs: "16px", sm: "24px", md: "32px" };

export const SECTION_GAP = { xs: "16px", sm: "20px", md: "24px" };

export const CARD_PADDING = { xs: "20px", sm: "24px", md: "28px" };

export const GRID_GAP = { xs: "12px", sm: "16px" };
